/* eslint-disable import/no-duplicates */
import React from 'react';
import PropTypes from 'prop-types';
import TimeseriesChart from 'charts/components/timeseries-chart';
import {FULL_WIDTH_LAYOUT} from 'charts/constants/layout-mode';
import {COLUMN_LAYOUT} from 'charts/constants/layout-mode';
import './index.scss';

/**
 * TrendsChart is a simple wrapper around the TimeseriesChart
 * component, giving it some styling and default props.
 */
export default class TrendsChart extends React.Component {
  static propTypes = {
    groups: PropTypes.array.isRequired,
    gutters: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.objectOf(PropTypes.number),
    ]),
    layoutMode: PropTypes.oneOf([COLUMN_LAYOUT, FULL_WIDTH_LAYOUT]),
  };

  static defaultProps = {
    gutters: 0,
    layoutMode: COLUMN_LAYOUT,
  };

  state = {
    height: 200,
  };

  render() {
    return (
      <div className={'TrendsChart'} style={{height: this.state.height}}>
        <TimeseriesChart
          groups={this.props.groups}
          gutters={this.props.gutters}
          layoutMode={this.props.layoutMode}
          onHeightUpdate={(height) => this.setState({height})}
        />
      </div>
    );
  }
}
